define([
    'jquery',
    'lodash',
    'WebCommon/toast/toast'
], function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'https://fnji.com';
    var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        // ridgeListApi: new Api('/m/s/SiteIndexEntity/ridge'),//山脊线产品（高端线）
        // earthListApi: new Api('/m/s/SiteIndexEntity/earth'),//大地线产品（高端线）
        // highListApi: new Api('/s/product-list/getLineProducts'),//高端线产品
        getIndexImagesApi: new Api('/m/s/SiteIndexEntity/getIndexImages'),//首页图片

        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn')//中英文切换
    };
});



//////////////////
// WEBPACK FOOTER
// ../site/index2021/common/api.js
// module id = 56
// module chunks = 0 1 2 3 4 5 6 7 8